<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách xe tuyến"
          :link="[
            {
              text: 'Xe tuyến',
              href: '../busList'
            }
          ]"
        />
      </div>
      <div class="flex-center" v-if="isEditDocument">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog"> Thêm tuyến mới </v-btn>
      </div>
    </div>

    <v-card v-if="role.type !== 'buslist'" outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BusFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <BusDataTable ref="busesDataTable" :type="'busDataTable'" :selected.sync="selected" />
    </v-card>
    <BusNewDialog :state="newDialog" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import { mapGetters } from 'vuex'
import BusFilter from '@/modules/bus/BusFilter'
import BusDataTable from '@/modules/bus/BusDataTable.vue'
import BusNewDialog from '@/modules/bus/busNewDialog.vue'

export default {
  components: {
    Breadcrumbs,
    BusFilter,
    BusDataTable,
    BusNewDialog
  },
  props: {},
  data() {
    return {
      newDialog: false,
      selected: [],
      description: '',
      name: '',
      status: '',
      driver: '',
      phone: '',
      data: {
        maxStudent: ''
      },
      maxStudent: '',
      statusDefault: 'active'
    }
  },
  computed: {
    ...mapGetters('auth', ['profile', 'role', 'user', 'isEditDocument'])
  },
  methods: {
    async refresh(query) {
      this.$refs.busesDataTable.refresh(query)
    }
  },
  created() {
    this.status = this.statusDefault
  }
}
</script>
<style scoped></style>
